import { useState, useEffect, useCallback } from 'react';

// 스토어 URL 상수 정의
const STORE_URLS = {
    ANDROID: 'https://play.google.com/store/apps/details?id=com.cmcnu.careplus',
    IOS: 'https://apps.apple.com/kr/app/케어플러스/id6754904057'
};

const compareVersion = (a, b) => {
    if (!a || !b) return 0;
    const aParts = a.split('.').map(Number);
    const bParts = b.split('.').map(Number);

    for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const aVal = aParts[i] || 0;
        const bVal = bParts[i] || 0;
        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
    }
    return 0;
};

const useAppVersionCheck = () => {
    const [versionInfo, setVersionInfo] = useState({
        currentVersion: '',
        latestVersion: '',
        needsUpdate: false,
        isLoaded: false,
        storeUrl: '' // 스토어 URL 상태 추가
    });

    useEffect(() => {
        const handleMessage = (e) => {
            try {
                const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;

                if (data.type === 'NATIVE_OS_INFO') {
                     window.isIOS = data.isIOS; 
                }

                if (data.type === 'APP_VERSION_INFO') {
                    const isIOS = window.isIOS || /iPhone|iPad|iPod/i.test(navigator.userAgent);
                    
                    const targetUrl = isIOS ? STORE_URLS.IOS : STORE_URLS.ANDROID;
                    
                    // 버전 비교
                    const needsUpdate = compareVersion(data.currentVersion, data.latestVersion) < 0;

                    setVersionInfo({
                        currentVersion: data.currentVersion,
                        latestVersion: data.latestVersion,
                        needsUpdate,
                        isLoaded: true,
                        storeUrl: targetUrl // 결정된 URL 저장
                    });
                }
            } catch (err) {
                console.error('Version Check Error:', err);
            }
        };

        const target = window.document || window;
        target.addEventListener('message', handleMessage);
        window.addEventListener('message', handleMessage);

        // 앱 버전 요청
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'REQUEST_APP_VERSION'
            }));
        }

        return () => {
            target.removeEventListener('message', handleMessage);
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const openStore = useCallback((url) => {
        const targetUrl = url || versionInfo.storeUrl || STORE_URLS.ANDROID;

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: targetUrl
            }));
        } else {
            window.open(targetUrl, '_blank');
        }
    }, [versionInfo.storeUrl]);

    return {
        ...versionInfo,
        openStore,
        isApp: !!window.ReactNativeWebView
    };
};

export default useAppVersionCheck;